import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Success = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // You can add PostHog event tracking here if needed, e.g.:
    // if (sessionId) {
    //   captureEvent('purchase_success', { session_id: sessionId });
    // }
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-50 to-white">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-blue-600 mb-4">Thank You!</h1>
        <p className="text-xl text-gray-600">Your payment was successful.</p>
      </div>
    </div>
  );
};

export default Success;
